module.exports = __webpack_public_path__ + "img/menu2.60268f4c.png";